import type { Business } from "@/types/business";
import { useQuery, keepPreviousData } from "@tanstack/react-query";

export interface BusinessesResponse {
  data: Business[];
  total: number;
}

export interface BusinessSearchParams {
  search?: string;
  address?: string;
  distance?: string;
}

export function useBusinesses(params: BusinessSearchParams) {
  return useQuery({
    queryKey: ["businesses", params],
    queryFn: async () => {
      const config = await (globalThis as any)._appSettings;
      const base: string = config?.api_endpoint ?? "";
      const tenant: string = config?.directory_partner ?? "";

      const body: Record<string, string> = {};
      if (params.search?.trim()) {
        body.search = params.search.trim();
      }
      if (params.address?.trim()) {
        body.address = params.address.trim();
      }
      if (params.distance?.trim()) {
        body.distance = params.distance.trim();
      }

      const res = await fetch(`${base}api/businesses?tenant=${encodeURIComponent(tenant)}`, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        throw new Error(`API error ${res.status}`);
      }

      return res.json() as Promise<BusinessesResponse>;
    },
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000, // serve cache instantly, background refetch after 2 min
    gcTime: 10 * 60 * 1000, // keep in memory for 10 min
  });
}
